import { Disable2Fa } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {},

  info: {
    dialog: {
      get title() {
        return '';
      },
      class: 'w-[420px] h-[460px]',
    },
  },
};

export default Disable2Fa;
